var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#b0bac5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.89201 5.62268C6.01703 5.4977 6.18657 5.42749 6.36335 5.42749C6.54012 5.42749 6.70966 5.4977 6.83468 5.62268L10 8.78801L13.1667 5.62268C13.2917 5.4977 13.4612 5.42749 13.638 5.42749C13.8148 5.42749 13.9843 5.4977 14.1093 5.62268L14.3787 5.89201C14.5037 6.01703 14.5739 6.18657 14.5739 6.36335C14.5739 6.54012 14.5037 6.70966 14.3787 6.83468L11.2107 10L14.3773 13.1653C14.5023 13.2904 14.5725 13.4599 14.5725 13.6367C14.5725 13.8135 14.5023 13.983 14.3773 14.108L14.108 14.3773C13.983 14.5023 13.8135 14.5725 13.6367 14.5725C13.4599 14.5725 13.2904 14.5023 13.1653 14.3773L9.99868 11.212L6.83468 14.3773C6.70966 14.5023 6.54012 14.5725 6.36335 14.5725C6.18657 14.5725 6.01703 14.5023 5.89201 14.3773L5.62268 14.108C5.4977 13.983 5.42749 13.8135 5.42749 13.6367C5.42749 13.4599 5.4977 13.2904 5.62268 13.1653L8.78801 10L5.62268 6.83468C5.4977 6.70966 5.42749 6.54012 5.42749 6.36335C5.42749 6.18657 5.4977 6.01703 5.62268 5.89201L5.89201 5.62268Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearCircleIcon);
export default __webpack_public_path__ + "static/media/clear_circle_icon.dac28c5268993dbc9fbb7aba6a0b0f9b.svg";
export { ForwardRef as ReactComponent };